import React from "react";
import { useTranslation } from "react-i18next";
import Grid from "@material-ui/core/Grid/Grid";
import uniqueId from "lodash/fp/uniqueId";
import Typography from "@material-ui/core/Typography/Typography";
import { useStyles } from "./styles";
import ArrowDownIcon from "../../../../icons/ArrowDownIcon";

const WarehouseListHeader: React.FC = () => {
  const { headerWrapper, firstItem } = useStyles();
  const { t } = useTranslation("analytics");

  return (
    <Grid container direction="row" alignItems="center" className={headerWrapper}>
      <ArrowDownIcon style={{ width: 16, height: 16, marginRight: 8 }} />
      <Grid item xs key={uniqueId("report")} className={firstItem}>
        <Typography variant="body2">{t("labels.reports.warehouse_code")}</Typography>
      </Grid>
      <Grid item xs key={uniqueId("report")}>
        <Typography variant="body2">{t("labels.reports.warehouse_name")}</Typography>
      </Grid>
      <Grid item xs key={uniqueId("report")}></Grid>
    </Grid>
  );
};
export default WarehouseListHeader;
